const dealerIntroNumber = "0161 524 0090";
const dealerSetupNumber = "0161 524 0056";
const dealerIntroEmail = "dealers@carfinance247.co.uk";

export {
    dealerIntroNumber,
    dealerSetupNumber,
    dealerIntroEmail
}